import Mainguest from './components/MainGuest.vue'
import RiepOspiti from './components/RiepilogoOspiti.vue'
import Istruzioni from './components/Istruzioni.vue'
import SelezionaProssimo from './components/SelezionaProssimo.vue'
import Upload from './components/Upload.vue'
import RaggruppamentoPiatti from './components/menu/RaggruppamentoPiatti.vue'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('mainguest', Mainguest),
    Vue.component('istruzioni', Istruzioni),
    Vue.component('seleziona-prossimo', SelezionaProssimo),
    Vue.component('riepilogo-ospiti', RiepOspiti)
    Vue.component('upload', Upload)
    Vue.component('raggruppamento-piatti', RaggruppamentoPiatti)
  }
}

export default GlobalComponents
